import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import Logo from '@/components/atoms/logo/logo';
import Typography from '@/components/atoms/typography/typography';
import prefixSvgIds from '@/components/utilities/svg-prefixer/svg-prefixer';
import { getBrandClassName } from '@/libraries/getters/get-brand-class-name';
import { getBrandName } from '@/libraries/getters/get-brand-name';
import { getLogoName } from '@/libraries/getters/get-logo-name';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './brand-teasers-logo.module.scss';

interface BrandTeasersLogoProps {
  brand: Content.Properties.Brand;
  className: string;
}

const BrandTeasersLogo = ({ className, brand }: BrandTeasersLogoProps) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  // use unique prefix for all ids in the svg to avoid conflicts when multiple logos are rendered on the same page
  useEffect(() => {
    prefixSvgIds(wrapperRef.current, `brandLogo`);
  }, [brand]);

  const logoName = getLogoName({ brand: brand, type: 'Symbol' });

  return (
    <div ref={wrapperRef} className={classNames(styles.component, className)}>
      <div className={styles.logoWrapper}>
        <Logo className={styles.logo} name={logoName} />
      </div>

      <div
        className={classNames(
          styles.textWrapper,
          getBrandClassName(brand, styles),
        )}
      >
        <Typography
          className={classNames(styles.text, styles.logoStyling)}
          tagStyle="bodyMediumBold"
        >
          {getBrandName(brand)}
        </Typography>
      </div>
    </div>
  );
};

BrandTeasersLogo.displayName = 'BrandTeasersLogo';

export default BrandTeasersLogo;
